import React from "react";
import classNames from "classnames";

import classes from "./style.module.scss";

import ErrorIcon from "assets/images/icons/warning-red.svg";
import WarningIcon from "assets/images/icons/WarningOrange.svg";
import GreenCheckIcon from "assets/images/icons/GreenCheck.svg";
import Info from "assets/images/icons/JSX/info";

const InfoDropdown = ({
    label = "",
    children,
    isWarning = false,
    isError = false,
    isSuccess = false,
    className,
    contentClassName,
}) => {
    const Icon = isError ? ErrorIcon : isWarning ? WarningIcon : isSuccess ? GreenCheckIcon : "";

    return (
        <div
            className={classNames(classes.dropdownContainer, {
                [classes.warning]: isWarning,
                [classes.error]: isError,
                [classes.success]: isSuccess,
                [className]: className,
            })}
        >
            <div className={classes.dropdownLabel}>
                {Icon ? <img src={Icon} alt="Icon" /> : <Info />}
                <p> {label} </p>
            </div>
            <div className={classNames(classes.dropdownContent, {
                [contentClassName]: contentClassName,
            })}>
                {children}
            </div>
        </div>
    )
};

export default InfoDropdown;